import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  groupCategory: {
    margin: '60px 0 20px',
    fontWeight: 400,
  },
  container: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  pageTitle: {
    fontWeight: 400,
  },
  actionCard: {
    minHeight: '160px',
  },
  actionCardWrapper: {
    border: '1px solid',
    transition: 'all .2s ease-in-out',
    '&:hover': {
      boxShadow: '0px 6px 20px 0px #dfdfdf',
    },
    '&.READ': {
      backgroundColor: theme.palette.grey[50],
      borderColor: theme.palette.grey[400],
    },
    '&.UPDATE': {
      backgroundColor: theme.palette.success.light,
      borderColor: theme.palette.success.main,
    },
    '&.CREATE': {
      backgroundColor: (theme.palette.primary as any).extraLight,
      borderColor: theme.palette.primary.dark,
    },
  },
}));

export default useStyles;
